import { TranslationContext, TranslationContextType } from "modules/translations/src/translation-context"
import { useContext } from "react"

export function useTranslations (): TranslationContextType {
    return useContext( TranslationContext )
}
